import React from "react";
import { toAbsoluteUrl } from "../../_metronic/utils/utils";
import styles from "../styles/HeaderAuth.module.scss";

function HeaderAuth() {
  return (
    <div className={styles.header}>
      <div className={styles.logo}>
        <img alt="logo" src={toAbsoluteUrl("/images/logo-white.png")} style={{ height: "24px" }} />
      </div>
    </div>
  );
}

export default HeaderAuth;
